export default class tile {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/dashboard/widgets/tile.html'),
            scope: {
                data: '=',
                header: '=',
                color: '='
            },
            controller: ['$scope', '$filter', 'ChartData', ($scope, $filter, ChartData) => {
                $scope.chartOptions = {
                    scaleShowLabels: false,
                    scaleShowGridLines: false,
                    scaleFontColor: '#73879C',
                    scaleFontSize: 10,
                    scaleFontWeight: 300
                };

                $scope.$watch('data', (newVal) => {
                    if (newVal) {
                        $scope.chartData = ChartData.setTileData(newVal.data, $scope.color);
                    }
                });
            }]
        }
    }
};
